import { mapGetters } from "vuex";
import { isSmallDevice } from "@/common/functions";

export default {
    name: "Advertising",
    data() {
        return {
            windowHeight: null,
            windowWidth: null,
            isMobileLeaderboard: false
        };
    },
    methods: {
        onWindowResize() {
            this.windowHeight =
                window.visualViewport?.height ||
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            this.windowWidth =
                window.visualViewport?.width ||
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            this.$store.commit("Screen/updateWindowProperties", {
                windowHeight: this.windowHeight,
                windowWidth: this.windowWidth
            });
        },

        onWindowScroll() {
            this.$store.commit(
                "Screen/updateWindowScroll",
                window.visualViewport?.pageTop || window.pageYOffset
            );
        }
    },
    computed: {
        ...mapGetters("Screen", ["inputHasFocus", "window"]),
        outerElementInlineStyle() {
            const s = {};

            /**
             * On iOS Safari, the keyboard overlaps on top of the layout viewport,
             * which means that window.innerHeight won't return the correct value.
             * In that case, we need to calculate the difference using the visual
             * viewport (which is the layout viewport minus the keyboard), and adjust the position of the ad accordingly.
             */
            if (
                this.isMobileLeaderboard &&
                typeof window.visualViewport === "object" &&
                this.inputHasFocus
            ) {
                s.bottom = "auto";

                const scrollY = this.window.scrollY;
                const windowHeight = this.window.windowHeight;
                const adHeight = 50;

                s.top = `${windowHeight + scrollY - adHeight}px`;
                s.position = "fixed";
            }

            return s;
        }
    },
    mounted() {
        this.isMobileLeaderboard = this.$el.classList.contains("anchor-ad") && isSmallDevice();
    },
    created() {
        if (typeof window.__PRERENDER_INJECTED === "undefined") {
            this.onWindowResize();
            this.onWindowScroll();

            const w = window.visualViewport || window;
            w.addEventListener("resize", this.onWindowResize);
            w.addEventListener("scroll", this.onWindowScroll);
        }
    },
    destroyed() {
        const w = window.visualViewport || window;
        w.removeEventListener("resize", this.onWindowResize);
        w.removeEventListener("scroll", this.onWindowScroll);
    }
};



// WEBPACK FOOTER //
// ./src/components/Advertising/Advertising.js